import React from "react";

function Footer() {
  return (
    <footer className="bg-dark text-white text-center py-3 mt-5 shadow-lg">
      © 2025 SpeedUp Infotech – Student Dashboard
    </footer>
  );
}

export default Footer;
